import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function Audit() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/audit?limit=300").then((r) => setRows(r.data)); }, []);
  return (
    <div className="p-6 md:p-10">
      <p className="text-xs tracking-[0.3em] uppercase text-[#E50914] mb-2">Trail</p>
      <h1 className="font-display text-3xl sm:text-4xl tracking-tight mb-6">Audit Log</h1>
      <div className="bg-[#16161C] border border-[#2D2D35] rounded-md overflow-hidden">
        <table className="w-full" data-testid="audit-table">
          <thead>
            <tr className="text-[10px] uppercase tracking-widest text-zinc-500 border-b border-[#2D2D35]">
              <th className="text-left p-3">When</th>
              <th className="text-left p-3">Actor</th>
              <th className="text-left p-3">Action</th>
              <th className="text-left p-3">Target</th>
              <th className="text-left p-3">Meta</th>
            </tr>
          </thead>
          <tbody className="font-mono text-xs">
            {rows.map((r) => (
              <tr key={r.id} className="border-b border-[#2D2D35]/60 hover:bg-[#1C1C24]">
                <td className="p-3 text-zinc-400">{r.at?.slice(0, 19).replace("T"," ")}</td>
                <td className="p-3">{r.actor_id?.slice(0, 8)}…</td>
                <td className="p-3"><span className="px-2 py-1 rounded bg-[#E50914]/10 text-[#E50914]">{r.action}</span></td>
                <td className="p-3 text-zinc-300">{r.target?.slice(0, 12)}…</td>
                <td className="p-3 text-zinc-500 text-[10px]">{JSON.stringify(r.meta || {})}</td>
              </tr>
            ))}
            {!rows.length && <tr><td colSpan="5" className="text-center text-zinc-500 p-8 text-sm">Empty.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
